import { EmptyState } from "@/components/data-table/_components/empty-state";
import { ShieldOffIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

interface CustomerCompanyGroupScopeEmptyStateProps {
  className?: string;
}

/**
 * Shown in place of customer-scoped tables when the user is not a masterdata administrator and holds no `CG.*`
 * attribute app role. The API always answers with an empty list for such users, so an empty table would read as
 * "no data" while the real cause is "no company group assignment".
 */
export function CustomerCompanyGroupScopeEmptyState({ className }: CustomerCompanyGroupScopeEmptyStateProps) {
  const { t } = useTranslation(["masterdata"]);

  return (
    <EmptyState
      className={className}
      noDataIcon={ShieldOffIcon}
      noDataTitle={t("masterdata:NoCompanyGroupAssigned")}
      noDataDescription={t("masterdata:NoCompanyGroupAssignedDescription")}
    />
  );
}
